<template>
  <div class="contenedor-programacion-listado-desktop">
    <v-container
      fluid>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-card flat color="base4" >
            <v-card-title>
              Oficios de Autorización
            </v-card-title>

            <!-- tabla Oficios Autorización-->
            <template>
              <v-data-table
              :headers="getHeaders"
              :items="listadoOficiosAutorizacion"
              item-key="id"
              v-model="selectedRows"
              sort-by="createdAt"
              sort-desc
              :items-per-page="15"

              >
              <template v-slot:[`item.numero`]="{ item }" >
                <tr :class="selectedRows.indexOf(item.id)>-1?'selected':''"
                  @click="verDetalle(item)"
                  style="cursor: pointer">
                  <td  class="pb-2">
                    <span class="secondary--text font-weight-bold">
                      {{ item.numero }}
                    </span>
                  </td>
                </tr>
              </template>
              <template v-slot:[`item.tipo`]="{ item }">
                <span v-if="item.tipo === 'AUTORIZACIÓN'" class="secondary--text ">
                      A
                    </span>
                    <span v-if="item.tipo === 'CANCELACIÓN'" class="base2--text">
                      C
                    </span>
              </template>
              <template v-slot:[`item.fecha`]="{ item }">
                {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString('es-MX') }}
              </template>
              <template v-slot:[`item.importe`]="{ item }">
                    <span class="">
                      <v-chip :color="getColorSumaOficioDetalles(item)">
                        {{item.importe | currency}}
                      </v-chip>
                    </span>
              </template>
              <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
                <opciones
                :oficio="item"></opciones>
              </template>
            </v-data-table>
          </template>
          <!-- Termina tabla Oficios Autorización-->

          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-card flat color="bkground" >
            <v-card-title>
              Recursos
              <v-spacer></v-spacer>
              <v-chip :color="getColorSumaDetalles">{{getSumaDetalles | currency}}</v-chip>
              <v-btn
                v-if="(selectedRows.length > 0) && (mixValidaScopesActions(1))"
                small
                color="secondary"
                class="rounded-lg"
                dark
                @click="registrarNuevoOficioDetalle">
                <span>+</span>
              </v-btn>
            </v-card-title>
            <!-- Tabla Detalle-->
            <template>
              <v-data-table
                :headers="headersDetalle"
                :items="getOficioDetalles"
                item-key="item.id"
                sort-by="createdAt"
                sort-desc
                :items-per-page="100"
                hide-default-footer
              >
              <template v-slot:[`item.obra.meta`]="{ item }">
                <cortar-textos
                :texto="item.obra.meta">
                </cortar-textos>
              </template>
              <template v-slot:[`item.importe`]="{ item }">
                {{item.importe | currency}}
              </template>
              <template v-slot:[`item.clavePresupuestal`]="{ item }">
                {{item.clavePresupuestal}}
              </template>
              <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
                <v-tooltip
                  v-if="mixValidaScopesActions(3)"
                  top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="borrarDetalle(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar</span>
                </v-tooltip>
              </template>
              </v-data-table>
            </template>
            <!-- Termina tabla Detalle-->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
        persistent
        v-model="mostrarVentanaRegistrarNuevoOficioDetalle"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
        <registrar-nuevo-oficio-detalle
            v-if="mostrarVentanaRegistrarNuevoOficioDetalle"
            v-on:cerrar="cerrarRegistrarNuevoOficioDetalle"
            :oficio="oficioAutorizacionSelected"
            :sumaDetalles="getSumaDetalles">
        </registrar-nuevo-oficio-detalle>
    </v-dialog>
  </div>
</template>
<script>

import CortarTextos from '@/components/CortarTextos.vue';
import RegistrarNuevoOficioDetalle from '@/components/administracion/programacion/oficiosautorizacion/oficiosautorizaciondetalle/Nuevo.vue';
import eventBus from '@/helpers/eventBus';
import Opciones from '@/views/administracion/programacion/listado/Opciones.vue';

export default {
  name: 'ProgramacionListadoDesktop',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    listadoOficiosAutorizacion: {
      type: Array,
      required: true,
    },
  },
  components: {
    CortarTextos,
    RegistrarNuevoOficioDetalle,
    Opciones,
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: true,
          value: 'numero',
          width: '40%',
        },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Tipo', value: 'tipo' },
        {
          text: 'Importe', width: '30%', align: 'end', value: 'importe',
        },
        {
          text: '',
          sortable: false,
          align: 'end',
          width: '5%',
          value: 'acciones',
        },

      ],
      headersDetalle: [
        {
          text: 'Obra', align: 'start', sortable: false, value: 'obra.meta',
        },
        { text: 'Importe', align: 'end', value: 'importe' },
        {
          text: 'Clave Presupuestal',
          align: 'start',
          sortable: true,
          value: 'clavePresupuestal',
        },
        {
          text: '',
          sortable: false,
          align: 'end',
          width: '50',
          value: 'acciones',
        },
      ],
      mostrarVentanaRegistrarNuevoOficioDetalle: false,
      entroAgregarNuevoOficioDetalle: false,
      entroEliminarNuevoOficioDetalle: false,
      selectedRows: [],
      oficioAutorizacionSelected: {},
      idOficio: null,
      colorOficioImporte: '',
      // numeroEjercicio: new Date().getFullYear(),

    };
  },

  methods: {
    borrarDetalle(oficioAutorizacionDetalle) {
      eventBus.$emit('eliminar-oficio-autorizacion-detalle', oficioAutorizacionDetalle);
      this.entroEliminarNuevoOficioDetalle = true;
    },
    verDetalle(oficio) {
      this.selectedRows = [oficio.id];
      this.oficioAutorizacionSelected = oficio;
    },
    registrarNuevoOficioDetalle() {
      this.mostrarVentanaRegistrarNuevoOficioDetalle = true;
      this.entroAgregarNuevoOficioDetalle = true;
    },
    cerrarRegistrarNuevoOficioDetalle() {
      this.mostrarVentanaRegistrarNuevoOficioDetalle = false;
    },
    getColorSumaOficioDetalles(oficio) {
      if (this.$ObjSumar(oficio.detalles, 'importe') === oficio.importe) { return 'success'; }
      return 'warning';
    },
  },
  computed: {
    getHeaders() {
      return this.headers;
    },
    getHeadersDetalle() {
      return this.headersDetalle;
    },
    getOficioDetalles() {
      if (!this.listadoOficiosAutorizacion) return [];
      const oficio = this.listadoOficiosAutorizacion
        .find((o) => o.id === this.selectedRows[0]);
      if (!oficio) return [];
      return oficio.detalles;
    },
    getSumaDetalles() {
      const detalles = this.getOficioDetalles;
      const suma = detalles
        .map((d) => d.importe)
        .reduce((p, n) => p + n, 0);
      return suma;
    },
    getColorSumaDetalles() {
      if (this.$ObjSumar(this.getOficioDetalles, 'importe') === 0) { return 'bkground'; }
      if (this.oficioAutorizacionSelected.importe === this.$ObjSumar(this.getOficioDetalles, 'importe')) { return 'success'; }
      return 'warning';
    },

  },
  watch: {
    listadoOficiosAutorizacion() {
      if (this.selectedRows.length > 0 && !this.entroAgregarNuevoOficioDetalle
      && !this.entroEliminarNuevoOficioDetalle) {
        this.selectedRows = [];
        this.oficioAutorizacionSelected = {};
      }
      this.entroAgregarNuevoOficioDetalle = false;
      this.entroEliminarNuevoOficioDetalle = false;
    },
  },
};
</script>
